import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import moment from "moment-timezone";
export default {
  name: "MaintenanceCountdown",
  data: function data() {
    return {
      timeLeft: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      countdownTimer: null,
      isExpired: false
    };
  },
  computed: {
    maintenanceStartMoment: function maintenanceStartMoment() {
      return moment.utc(this.$maintenanceMode.startTime);
    },
    expirationMoment: function expirationMoment() {
      return moment.utc(this.$maintenanceMode.expirationTime);
    },
    isTimeFinished: function isTimeFinished() {
      return this.timeLeft.days === 0 && this.timeLeft.hours === 0 && this.timeLeft.minutes === 0 && this.timeLeft.seconds === 0;
    }
  },
  filters: {
    padZero: function padZero(value) {
      return value.toString().padStart(2, "0");
    }
  },
  mounted: function mounted() {
    this.startCountdown();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopCountdown();
  },
  methods: {
    startCountdown: function startCountdown() {
      this.updateCountdown();
      this.countdownTimer = setInterval(this.updateCountdown, 1000);
    },
    stopCountdown: function stopCountdown() {
      clearInterval(this.countdownTimer);
    },
    updateCountdown: function updateCountdown() {
      var now = moment.utc();
      var remainingDuration = moment.duration(this.expirationMoment.diff(now));
      this.isExpired = remainingDuration.asSeconds() <= 0 || !this.$maintenanceMode.isActive;
      if (this.isExpired) {
        this.timeLeft = {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
      } else {
        this.timeLeft = {
          days: Math.floor(remainingDuration.asDays()),
          hours: remainingDuration.hours(),
          minutes: remainingDuration.minutes(),
          seconds: remainingDuration.seconds()
        };
      }
    },
    formatDuration: function formatDuration(duration) {
      return "".concat(Math.max(0, Math.floor(duration.asDays())), "d ").concat(duration.hours(), "h ").concat(duration.minutes(), "m ").concat(duration.seconds(), "s");
    }
  },
  watch: {
    "$maintenanceMode.isActive": {
      immediate: true,
      handler: function handler(newValue) {
        if (newValue) {
          this.startCountdown();
        } else {
          this.stopCountdown();
        }
      }
    },
    "$maintenanceMode.expirationTime": "updateCountdown",
    "$maintenanceMode.startTime": "updateCountdown"
  }
};